import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import {
  allLocations,
  addFavourite,
  removeFavourite,
  getFilteredProducts,
} from '../../../services/product';
import { viewUser } from '../../../services/user';
import { isAuthenticated } from '../../../services/auth';
import moment from 'moment';
import { prices } from '../../../components/ui/inputs/PriceRange';
import ProductCard from '../../../components/product/ProductCard';
import {
  Pagination,
  Empty,
  Tooltip,
  Button,
  Drawer,
  Radio,
  Space,
  message,
} from 'antd';
import Footer from '../../../components/layout/Footer';
import './CategoryView.css';

const API = (process.env.REACT_APP_API ).replace(/\/api$/, '');

const CategoryView = ({ match }) => {
  const countPerPage = 10;
  const [products, setProducts] = useState([]);
  const [current, setCurrent] = useState(1);
  const [pagination, setPagination] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [favourite, setFavourite] = useState(false);
  const [locations, setLocations] = useState([]);
  const [locationVisible, setLocationVisible] = useState(false);
  const [filter, setFilter] = useState({
    condition: '',
    price: [],
    category: match.params.categoryId,
    location: '',
  });
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');
  const [locationName, setLocationName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [sortBy, setSortBy] = useState('-1');
  const [drawerVisible, setDrawerVisible] = useState(false);

  const { user, token } = isAuthenticated();
  const { condition, price, location } = filter;

  // Responsividade
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Carregar dados
  useEffect(() => {
    const loadUser = async () => {
      if (user && token) {
        const res = await viewUser(user._id);
        setFavourites(res.data.favourites);
      }
    };
    const loadLocations = async () => {
      const res = await allLocations();
      setLocations(res.data);
    };
    loadUser();
    loadLocations();
  }, []);

  useEffect(() => {
    setFilter(prev => ({ ...prev, category: match.params.categoryId }));
  }, [match.params.categoryId]);

  useEffect(() => {
    const loadFilteredResults = async (page = 1) => {
      const res = await getFilteredProducts(filter, sortBy);
      setCurrent(page);
      const to = page * countPerPage;
      const from = to - countPerPage;
      setPagination(res.data.slice(from, to));
      setProducts(res.data);
      if (res.data.length > 0) {
        setCategoryName(res.data[0].category.name);
      }
    };
    loadFilteredResults(current);
    // eslint-disable-next-line
  }, [price, condition, sortBy, location, favourite, current, filter.category]);

  // Ativos
  const checkActive = products.some(product => product.status === 'active');

  // Handlers
  const handleSorted = (e) => setSortBy(e.target.value);
  const handleCondition = (e) => setFilter({ ...filter, condition: e.target.value });
  const handlePriceRange = (e) => {
    setFilter({ ...filter, price: e.target.value });
    setMin('');
    setMax('');
  };
  const handleAddFavourite = async (productId) => {
    await addFavourite(productId, { user, token });
    // Atualiza a lista de favoritos imediatamente
    setFavourites((prev) => [...prev, productId]);
    message.success('Adicionado aos favoritos');
  };
  const handleRemoveFavourite = async (productId) => {
    await removeFavourite(productId, { user, token });
    // Remove da lista de favoritos imediatamente
    setFavourites((prev) => prev.filter((id) => id !== productId));
    message.error('Removido dos favoritos');
  };
  Number.prototype.format = function (n = 0, x = 3) {
    var re = '\\d(?=(\\d{' + x + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };
  const handleLocation = () => setLocationVisible(true);
  const handleLocationFilter = (id, name) => {
    setFilter({ ...filter, location: id });
    setLocationVisible(false);
    setLocationName(name || '');
  };
  const handleLocationCLose = () => setLocationVisible(false);

  const handleMin = (e) => setMin(e.target.value);
  const handleMax = (e) => setMax(e.target.value);
  const handleSubmitPrice = () => {
    if (!min || !max) {
      message.error('Preencha os dois campos de preço');
      return;
    }
    setFilter({ ...filter, price: [parseInt(min), parseInt(max)] });
  };

  // Drawer de filtro mobile
  const FilterDrawer = () => (
    <Drawer
      title="Filtrar"
      placement="left"
      onClose={() => setDrawerVisible(false)}
      visible={drawerVisible} // troque 'open' por 'visible' para compatibilidade
      width={isMobile ? '90vw' : 350}
      bodyStyle={{ padding: 16 }}
    >
      {FilterContent()}
    </Drawer>
  );

  // Drawer de localização
  const LocationDrawer = () => (
    <Drawer
      title="Localizações"
      placement="left"
      onClose={handleLocationCLose}
      visible={locationVisible} // troque 'open' por 'visible'
      width={isMobile ? '90vw' : 350}
      bodyStyle={{ padding: 0 }}
    >
      <div
        className="list-group"
        style={{ maxHeight: 400, overflowY: 'auto' }}
      >
        <button
          className="list-group-item list-group-item-action"
          onClick={() => handleLocationFilter('', '')}
        >
          Todas as Localizações
        </button>
        {locations.map((l, i) => (
          <button
            key={i}
            className="list-group-item list-group-item-action"
            onClick={() => handleLocationFilter(l._id, l.name)}
          >
            {l.name}
          </button>
        ))}
      </div>
    </Drawer>
  );

  // Conteúdo do filtro (usado no Drawer e na sidebar)
  const FilterContent = () => (
    <div className="modern-filter-container">
      <Button
        className='modern-location-btn mb-3'
        size='large'
        onClick={handleLocation}
      >
        <i className='fas fa-map-marked-alt me-2'></i>
        {location === '' ? 'Selecionar Localização' : `${locationName} - Estado`}
      </Button>
      <strong>
        <p className='text-dark1 mb-2 mt-3 letter-spacing-02'>Condição</p>
      </strong>
      <Radio.Group onChange={handleCondition} value={condition} className="modern-radio-group">
        <Space direction='vertical'>
          <Radio value={''} className="modern-radio">Qualquer</Radio>
          <Radio value={'New'} className="modern-radio">Novo</Radio>
          <Radio value={'Used'} className="modern-radio">Usado</Radio>
        </Space>
      </Radio.Group>
      <hr className="margin-hr" />
      <strong>
        <p className='text-dark1 mb-2'>Faixa de preço</p>
      </strong>
      <div className='mb-2'>
        <Radio.Group onChange={handlePriceRange} value={price} className="modern-radio-group">
          <Space direction='vertical'>
            {prices.map((p, i) => (
              <Radio key={i} value={p.array} className="modern-radio">
                {p.name.replace('to', 'até').replace('Above', 'Acima de').replace('Any', 'Qualquer').replace('Price', 'Preço').replace('R$', 'R$ ')}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </div>
      <span className="modern-price-label">Preço personalizado:</span>
      <div className='form-group d-flex justify-content-center align-items-center mb-3 modern-price-row'>
        <div className='input-group input-group-sm me-2 modern-input-group'>
          <span className='input-group-text modern-input-group-text'>R$</span>
          <input
            type='number'
            className='form-control modern-input shadow-none'
            value={min}
            onChange={handleMin}
            placeholder="Mín"
            min={0}
          />
        </div>
        <div className="modern-ate">até</div>
        <div className='input-group input-group-sm ms-2 modern-input-group'>
          <span className='input-group-text modern-input-group-text'>R$</span>
          <input
            type='number'
            className='form-control modern-input shadow-none'
            value={max}
            onChange={handleMax}
            placeholder="Máx"
            min={0}
          />
        </div>
        <Button
          onClick={handleSubmitPrice}
          type="primary"
          size="small"
          className="modern-ok-btn ms-2"
        >
          OK
        </Button>
      </div>
      {LocationDrawer()}
    </div>
  );

  // Renderizar card de produto usando o componente ProductCard
  const renderProductCard = (product) => (
    <ProductCard
      key={product._id}
      product={product}
      showActions={false}
      showAuthor={true}
    />
  );

  return (
    <>
      <div className='container-fluid px-1 px-md-4 mb-5 category-container'>
      <Breadcrumb className="mb-3">
        <Breadcrumb.Item>
          <Link to='/' className='text-decoration-none'>
            Início
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{categoryName}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="row">
        {/* Filtro lateral desktop */}
        {!isMobile && (
          <div className='col-md-3 mb-3'>
            <div className='card rounded-3 card-shadow category-sidebar'>
              <div className='card-header p-3'>
                {FilterContent()}
              </div>
            </div>
          </div>
        )}

        {/* Conteúdo principal */}
        <div className={isMobile ? 'col-12' : 'col-md-9'}>
          {/* Botão filtro mobile */}
          {isMobile && (
            <>
              <Button
                type="primary"
                className="mb-3 w-100 filter-btn"
                onClick={() => setDrawerVisible(true)}
              >
                <i className="fas fa-filter me-2"></i>Filtrar
              </Button>
              {FilterDrawer()}
            </>
          )}

          <div className='card rounded-3 card-shadow mb-3'>
              <div className='header-category'>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h2 className={`category-header-title ${isMobile ? 'category-header-title-mobile' : ''} mb-0`}>
                    {products.length > 0
                      ? `${products[0].category.name} ${location ? `em ${locationName}` : '- Brasil'}`
                      : 'Nenhum produto encontrado'}
                  </h2>
                </div>
                <div style={{ flex: isMobile ? '1 1 100%' : '0 0 auto', minWidth: isMobile ? '100%' : 'auto' }}>
                  <p className='mb-2' style={{ fontSize: '13px', fontWeight: '500', color: '#6c757d' }}>
                    Ordenar por:
                  </p>
                  <select
                    className='form-select form-select-sm shadow-none'
                    style={{ width: '100%' }}
                    onChange={handleSorted}
                  >
                    <option value='-1'>Mais recentes</option>
                    <option value='1'>Mais antigos</option>
                  </select>
                </div>
            </div>
            <div className='container-products'>
              {!checkActive && <Empty description="Nenhum produto encontrado" />}
              {checkActive && (
                <>
                  {pagination.filter(p => p.status === 'active').length === 0 && (
                    <div className="text-center text-muted py-5">Nenhum produto encontrado.</div>
                  )}
                  <div className='products-grid'>
                    {pagination.filter(p => p.status === 'active').map(renderProductCard)}
                  </div>
                  <div className="pagination-container mt-4" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Pagination
                      pageSize={countPerPage}
                      onChange={page => setCurrent(page)}
                      current={current}
                      total={products.length}
                      className="custom-pagination"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoryView;
